import React, { useReducer } from 'react';
import festive1 from './Images/festive -1.png'
import festive2 from './Images/festive -2.jpg'
import festive3 from './Images/festive -3.jpg'
import festive4 from './Images/festive -4.png'
import festive5 from './Images/festive -5.jpg'
import festive6 from './Images/festive -6.png'
import festive7 from './Images/festive -7.png'

const slides = [
  {
    title: "",
    subtitle: "",
    description: "",
    image:`${festive1}`
  },
  {
    title: "",
    subtitle: "",
    description:"" ,
    image:
    `${festive2}`  
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:`${festive3}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${festive4}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${festive5}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${festive6}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${festive7}`
  }
];

function useTilt(active) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (!ref.current || !active) {
      return;
    }

    const state = {
      rect: undefined,
      mouseX: undefined,
      mouseY: undefined
    };

    let el = ref.current;

    const handleMouseMove = (e) => {
      if (!el) {
        return;
      }
      if (!state.rect) {
        state.rect = el.getBoundingClientRect();
      }
      state.mouseX = e.clientX;
      state.mouseY = e.clientY;
      const px = (state.mouseX - state.rect.left) / state.rect.width;
      const py = (state.mouseY - state.rect.top) / state.rect.height;

      el.style.setProperty("--px", px);
      el.style.setProperty("--py", py);
    };

    el.addEventListener("mousemove", handleMouseMove);

    return () => {
      el.removeEventListener("mousemove", handleMouseMove);
    };
  }, [active]);

  return ref;
}

const initialState = {
  slideIndex: 0
};

const slidesReducer = (state, event) => {
  if (event.type === "NEXT") {
    return {
      ...state,
      slideIndex: (state.slideIndex + 1) % slides.length
    };
  }
  if (event.type === "PREV") {
    return {
      ...state,
      slideIndex:
        state.slideIndex === 0 ? slides.length - 1 : state.slideIndex - 1
    };
  }
};

function Slide({ slide, offset }) {
  const active = offset === 0 ? true : null;
  const ref = useTilt(active);

  return (
    <div
      ref={ref}
      className="slide"
      data-active={active}
      style={{
        "--offset": offset,
        "--dir": offset === 0 ? 0 : offset > 0 ? 1 : -1
      }}
    >
      <div
        className="slideBackground"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      />
      <div
        className="slideContent"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      >
        <div className="slideContentInner">
          <h2 className="slideTitle">{slide.title}</h2>
          <h3 className="slideSubtitle">{slide.subtitle}</h3>
          <p className="slideDescription">{slide.description}</p>
        </div>
      </div>
    </div>
  );
}

export default function FestivalPost() {
  const [state, dispatch] = React.useReducer(slidesReducer, initialState);

  return (
    <>
    <div className='' style={{background:''}} >
    <div className="slides" style={{overflow:'hidden', background:''}}>
      <button className='slide-btn' onClick={() => dispatch({ type: "PREV" })} >‹</button>

      {[...slides, ...slides, ...slides].map((slide, i) => {
        let offset = slides.length + (state.slideIndex - i);
        return <Slide slide={slide} offset={offset} key={i} />;
      })}
      <button className='slide-btn ' onClick={() => dispatch({ type: "NEXT" })} >›</button>
    </div>
    </div>
       </>
  );
}
